import { defineComponent as _defineComponent } from 'vue'
import { useReportingStore } from '@/views/Tools/Reporting/store';
import LoginCard, { LoginCardProps } from '@sh/components/Login/LoginCard.ts.vue';
import LoginForm from '@sh/components/Login/LoginForm.ts.vue';
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Login.ts',
  setup(__props) {

const loginCards: LoginCardProps[] = [
  {
    icon: 'clickFlareLogoSmall',
    title: 'ClickFlare',
    description: 'The Most Used Tracker by Supper Affiliates for:',
    features: ['Affiliate Offers', 'Search Arbitrage', 'Lead Generation/eCom'],
    button: {
      text: 'Get Started for Free',
      href: 'https://clickflare.com/?utm_campaign=optimizer_login_page&cpid=63c058719097e90012994076',
    },
  },
  {
    icon: 'landerLabLogoSmall',
    title: 'LanderLab',
    description: 'The Top Landing Page Builder For Affiliates:',
    features: [
      '100s of High Converting Affiliate Landing Pages',
      'Import landers from any URL, Adplexity or Anstrex',
      'Collect Leads and push to your CRM',
    ],
    button: {
      text: 'Get Started for Free',
      href: 'https://landerlab.io/?utm_campaign=optimizer_login_page&cpid=64dfe122de76b90012195cc6',
    },
  },
];

useReportingStore().$reset();

const currentYear = computed(() => new Date().getFullYear());

return { __sfc: true,loginCards, currentYear, LoginCard, LoginForm, OptimizerIconV2 }
}

})